import * as React from 'react';
import { WebAPI } from '../../../../MedicareProAPI/API/WebAPI';
import StyledModal from '../../StyledModal';
import { UserRepository } from '../../../../MedicareProAPI/Repositories/User/UserRepository';
import { MultiSelectModal } from './MultiSelectModal';
import type { SelectMap } from '../../../Utilities/SelectMap';
import { MultiSelect } from './MultiSelect';
import { UserFlagRepository } from '../../../../MedicareProAPI/Repositories/User/UserFlagRepository';

export interface UserFlagSelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (userLeadStatus: string[]) => void;

  value: string[];
}

export const UserFlagSelect = (props: UserFlagSelectProps): React.JSX.Element => {
  const [userFlags, setUserFlags] = React.useState<any>(null);
  const [userFlagsLoading, setUserFlagsLoading] = React.useState<boolean>(false);

  const [value, setValue] = React.useState<string[]>(props.value);

  const userFlagRepository = new UserFlagRepository();
  userFlagRepository.setAccessToken(props.userAccessToken);

  React.useEffect(() => {
    setUserFlagsLoading(true);

    userFlagRepository.getUserFlags(props.userId).then((response) => {
      setUserFlagsLoading(false);

      const options: SelectMap[] = [];

      response.getItems().forEach((item) => {
        options.push({
          value: item.getFlagColor(),
          label: item.getFlagMeaning(),
        });
      });

      setUserFlags(options);
    });
  }, []);

  return (
    <>
      <div>
        {userFlagsLoading === true && (
          <div className="alert small alert-info" role="alert">
            <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
          </div>
        )}
        {userFlagsLoading === false && userFlags && (
          <MultiSelectModal
            disabled={props.disabled}
            value={value}
            options={userFlags}
            modalSaveButtonLabel="Save Changes"
            modalTitle="Select Flags"
            buttonSelectLabel="Choose Flags"
            buttonEditLabel="Edit Flags"
            onChange={(newValue) => {
              setValue(newValue);

              if (props.onChange) {
                props.onChange(newValue);
              }
            }}
          />
        )}
      </div>
    </>
  );
};
